import { CanvasDimensions, DrawMode } from '@/entities/canvas';
import { useAppSelector } from '@/shared/hooks';
import { VIDEO_ASPECT_RATIO } from '@/shared/lib';
import { Line } from 'react-konva';

export function CrossHair({ stageSize }: { stageSize: CanvasDimensions }) {
  const pointer = useAppSelector((state) => state.canvas.mousePosition);
  const drawMode = useAppSelector((state) => state.canvas.drawMode);

  if (!(pointer && drawMode === DrawMode.Background)) {
    return null;
  }

  const height = stageSize.canvasWidth / VIDEO_ASPECT_RATIO;

  return (
    <>
      <Line
        points={[
          0,
          height * pointer.y,
          stageSize.canvasWidth,
          height * pointer.y,
        ]}
        stroke="red"
        strokeWidth={1}
        fill="red"
      />
      <Line
        points={[
          pointer.x * stageSize.canvasWidth,
          0,
          pointer.x * stageSize.canvasWidth,
          height,
        ]}
        stroke="red"
        strokeWidth={1}
        fill="red"
      />
    </>
  );
}
